import React, { useEffect, useState } from 'react';
import EventPast from './EventPast';
import EventUpcoming from './EventUpcoming';
import './EventMain.css';
import axios from 'axios';
import SmallLoader from './SmallLoader';

export default function EventMain() {
    const [tab, setTab] = useState("upcoming");
    const [upcomingEvents, setUpcomingEvents] = useState([]);
    const [pastEvents, setPastEvents] = useState([]);
    const [loadingUpcoming, setLoadingUpcoming] = useState(true);
    const [loadingPast, setLoadingPast] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const upcomingConfig = {
                    method: 'get',
                    url: `${process.env.REACT_APP_API_URL}/upcoming`,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    credentials: 'include',
                };
                const pastConfig = {
                    method: 'get',
                    url: `${process.env.REACT_APP_API_URL}/past`,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    credentials: 'include',
                };
                
                const [upcomingRes, pastRes] = await Promise.all([
                    axios.get(upcomingConfig.url, { withCredentials: true }),
                    axios.get(pastConfig.url, { withCredentials: true }),
                ]);
                
                console.log(upcomingRes.data);
                console.log(pastRes.data);
        
                setUpcomingEvents(upcomingRes.data);
                setPastEvents(pastRes.data);
            } catch (error) {
                console.log(error);
            } finally {
                setLoadingUpcoming(false); // Stop loading for upcoming events
                setLoadingPast(false); // Stop loading for past events
            }
        };

        fetchData();
    }, []);

    return (
        <div className="event-main">
            <div className="event-main-tabs">
                <div
                    className={`event-main-tab ${tab === "upcoming" ? "event-main-tab-active" : ""}`}
                    onClick={() => setTab("upcoming")}
                >
                    Upcoming Events
                </div>
                <div
                    className={`event-main-tab ${tab === "past" ? "event-main-tab-active" : ""}`}
                    onClick={() => setTab("past")}
                >
                    Past Events
                </div>
            </div>
            <svg className='margin_bottom' width="324" height="18" viewBox="0 0 324 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_265_19)">
                    <path fillRule="evenodd" clipRule="evenodd"
                        d="M170.955 9.9C170.986 9.6048 171 9.3042 171 9C171 4.0302 166.97 0 162 0C157.03 0 153 4.0302 153 9C153 9.3042 153.014 9.6048 153.045 9.9H149.4C149.4 6.4206 146.579 3.6 143.1 3.6C139.621 3.6 136.8 6.4206 136.8 9.9H129.665L123.365 3.6L117.065 9.9H111.487C111.087 8.3466 109.678 7.2 108 7.2C106.322 7.2 104.913 8.3466 104.513 9.9H0V10.8H104.4C104.4 12.789 106.011 14.4 108 14.4C109.989 14.4 111.6 12.789 111.6 10.8H117.837L123.365 16.3278L128.893 10.8H136.863C137.3 13.8528 139.927 16.2 143.1 16.2C146.273 16.2 148.9 13.8528 149.337 10.8H153.18C154.013 14.9076 157.646 18 162 18C166.354 18 169.987 14.9076 170.82 10.8H174.663C175.1 13.8528 177.727 16.2 180.9 16.2C184.073 16.2 186.7 13.8528 187.137 10.8H195.235L200.765 16.3278L206.293 10.8H212.4C212.4 12.789 214.011 14.4 216 14.4C217.989 14.4 219.6 12.789 219.6 10.8H324V9.9H219.487C219.087 8.3466 217.678 7.2 216 7.2C214.322 7.2 212.913 8.3466 212.513 9.9H207.065L200.765 3.6L194.465 9.9H187.2C187.2 6.4206 184.379 3.6 180.9 3.6C177.421 3.6 174.6 6.4206 174.6 9.9H170.955Z"
                        fill="#DB9E30" />
                </g>
                <defs>
                    <clipPath id="clip0_265_19">
                        <rect width="324" height="18" fill="white" />
                    </clipPath>
                </defs>
            </svg>
            <div className="event-main-content" style={{ minHeight: '200px' }}>
          {loadingUpcoming || loadingPast ? (
                  <div className="event-list">
                    <SmallLoader />
                  </div>
                ) : (
                    tab === "upcoming" ? <EventUpcoming Events={upcomingEvents} /> : <EventPast Events={pastEvents} />
                )}
            </div>
        </div>
    );
}
